export default function PageHeader({ eyebrow, title, description, align = "left" }) {
  return (
    <section className="bg-[#EDF1ED] border-b border-[#D5DDD7]">
      <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 ${align === "center" ? "text-center" : ""}`}>
        {eyebrow && (
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#1A3A32]">{eyebrow}</p>
        )}
        <h1 className="mt-4 text-5xl sm:text-6xl tracking-tight leading-none font-bold text-[#14241F]">
          {title}
        </h1>
        {description && (
          <p className={`mt-6 text-lg sm:text-xl text-[#495D56] max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
            {description}
          </p>
        )}
      </div>
    </section>
  );
}
